/**
 * 按照指定大小显示图片
 * aspectFill: 按指定大小充满屏，长边会被截取，原始比例
 * aspectFit: 按指定大小保证图片完全显示，原始比例
 * widthFix: 保持宽度，高度按原始比例自适应
 */
function parseUrl(url) {
  /**
   * 处理图片url
   */
  if (!url) return {}
  if (typeof url !== 'string') return {}
  var p2 = /-\d+-[\dC]*/
  if (p2.test(url)) {
    url = url.replace(p2, '')
  }
  var p3 = /^(.+\/\w+)(\.[^/]+?)$/
  var ymtImg = /https?:\/\/(img|video).yimutian.com/
  var rst = url.match(p3)

  if (rst) {
    if (rst[1].indexOf('http') !== 0 && rst[1].indexOf('//') !== 0) {
      if (rst[1][0] === '/') {
        rst[1] = 'http://img.yimutian.com' + rst[1]
      } else {
        rst[1] = 'http://img.yimutian.com/' + rst[1]
      }
    } else if (!rst[1].match(ymtImg)) {
      return {
        status: 'error',
        msg: 'Not ymt image'
      }
    }
    return {
      status: 'success',
      part0: rst[1],
      part1: rst[2]
    }
  } else {
    return {
      status: 'error',
      msg: 'Url parse error'
    }
  }
}

export const aspectFill = (url, width, height) => {
  /**
   * 按指定大小充满屏，长边会被截取，原始比例
   */
  var urlOb = parseUrl(url)
  if (urlOb.status === 'success') {
    return urlOb.part0 + '-' + width + '-' + height + 'C' + urlOb.part1
  } else {
    return url
  }
}

export const aspectFit = (url, width, height) => {
  /**
   * 按指定大小保证图片完全显示，原始比例
   */
  var urlOb = parseUrl(url)
  if (urlOb.status === 'success') {
    return urlOb.part0 + '-' + width + '-' + height + urlOb.part1
  } else {
    return url
  }
}
export const widthFix = (url, width) => {
  /**
   * 保持宽度，高度按原始比例自适应
   */
  var urlOb = parseUrl(url)
  if (urlOb.status === 'success') {
    return urlOb.part0 + '-' + width + '-' + urlOb.part1
  } else {
    return url
  }
}

export const fixPrefix = (url) => {
  /**
   * 只添加前缀
   */
  var urlOb = parseUrl(url)
  if (urlOb.status === 'success') {
    return urlOb.part0 + urlOb.part1
  } else {
    return url
  }
}
